/**
 * utils.js — Shared utility functions
 * Place at: src/lib/utils.js
 *
 * Previously formatTimeAgo was defined in CommentSection.jsx and
 * imported by NotificationBell.jsx — importing a large component file
 * just to get a utility function is fragile and loads unnecessary code.
 * Moved here as a single source of truth.
 */

/**
 * Format a date string into a human-readable relative time.
 * e.g. "just now", "5m", "3h", "2d"
 */
export function formatTimeAgo(dateStr) {
  if (!dateStr) return "";
  const diff = Date.now() - new Date(dateStr).getTime();
  const mins = Math.floor(diff / 60000);
  const hrs  = Math.floor(mins / 60);
  const days = Math.floor(hrs / 24);
  if (mins < 1)  return "just now";
  if (mins < 60) return `${mins}m`;
  if (hrs < 24)  return `${hrs}h`;
  return `${days}d`;
}